module.exports = __webpack_public_path__ + "img/hago.807de2b.png";